import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { resetHostScroll, setManualScrollRestoration } from '@/utils/qiankun';
import './index.scss';
import Header from './components/Header';
import CommonMenu from './components/CommonMenu';

const MainLayout = () => {
  const { pathname, search } = useLocation();
  const [menuVisible, setMenuVisible] = useState(
    !pathname.includes('/app/rentalCarReportDetail')
  );
  const isQiankunRoute = /^\/(ota|ota-ui|ota_ext)(\/|$)/.test(pathname);

  useEffect(() => {
    setManualScrollRestoration();
  }, []);

  useLayoutEffect(() => {
    resetHostScroll();
    const rafId = window.requestAnimationFrame(resetHostScroll);
    return () => {
      window.cancelAnimationFrame(rafId);
    };
  }, [pathname, search]);

  const changeMenu = () => {
    setMenuVisible((visible) => !visible);
  };

  const menuToggleLabel = menuVisible ? '收起左侧菜单' : '展开左侧菜单';

  return (
    <div className="main-layout-content">
      <Header />
      <div className="main-body-content">
        <div
          id="main-menu-content"
          className={`main-menu-content ${
            menuVisible
              ? 'main-menu-content--visible'
              : 'main-menu-content--hidden'
          }`}
          aria-hidden={!menuVisible}
        >
          <CommonMenu />
        </div>

        <div className="menu-wrap">
          <button
            type="button"
            className="menu-btn"
            onClick={changeMenu}
            aria-label={menuToggleLabel}
            aria-controls="main-menu-content"
            aria-expanded={menuVisible}
            title={menuToggleLabel}
          >
            <img
              src={
                menuVisible
                  ? require('@/assets/image/common/menu-retract.png')
                  : require('@/assets/image/common/menu-spread.png')
              }
              alt=""
            />
          </button>
        </div>

        <div className={`main${isQiankunRoute ? ' main--qiankun' : ''}`}>
          <div id="qiankun-root"></div>
          <Outlet></Outlet>
        </div>
      </div>
    </div>
  );
};
export default MainLayout;
